import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { t } from "i18next";
import { useCallback, useEffect, useState } from "react";
import { extractTranslated } from "../utils/helpers";
import { CategoryLookupModel } from "../store/features/categorySlice";
import ArrowDownIcon from "./Icons/ArrowDownIcon";
import { getCategoryLookup } from "../services/categoryService";
import { useDebounce } from "use-debounce";
import { InputLabel } from "@mui/material";

export interface CategorySelectProps {
  category: CategoryLookupModel | null;
  errors?: any;
  updateCategory: (town: CategoryLookupModel | null) => void;
}

export default function CategorySelect(props: CategorySelectProps) {
  const { updateCategory, category, errors } = props;

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm] = useDebounce(searchTerm, 1000);
  const [options, setOptions] = useState<readonly CategoryLookupModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadSuggestions = useCallback(async (query: string) => {
    setIsLoading(true);
    try {
      setOptions(await getCategoryLookup(query));
    } catch {}
    setIsLoading(false);
  }, []);

  useEffect(() => {
    loadSuggestions(debouncedSearchTerm);
  }, [loadSuggestions, debouncedSearchTerm]);

  useEffect(() => {
    setIsLoading(true);
  }, [searchTerm]);

  return (
    <>
      <InputLabel htmlFor="category-select" required variant="standard" shrink>
        {t("start.businessCategorySelection")}
      </InputLabel>
      <Autocomplete
        getOptionLabel={(option) => extractTranslated(option.value, "en-AU")}
        filterOptions={(option) => option}
        size="small"
        options={options}
        isOptionEqualToValue={(option, value) => option.key === value.key}
        popupIcon={<ArrowDownIcon />}
        loading={isLoading}
        value={category}
        onChange={(_, value) => updateCategory(value)}
        onInputChange={(_, value) => setSearchTerm(value)}
        inputValue={searchTerm}
        renderInput={(params) => (
          <TextField
            variant="outlined"
            {...params}
            InputProps={{
              ...params.InputProps,
              id: "category-select",
            }}
            error={errors != null}
            helperText={
              errors?.required ? t("start.validations.requiredField") : ""
            }
            placeholder={t("start.businessCategorySelectionPlaceholder")}
          />
        )}
      />
    </>
  );
}
